<template>
  <button class="rounded-md border-pink-500 ring-2 ring-pink-500 bg-white p-4 h-12 text-center align-middle text-pink-500 hover:bg-pink-600 hover:text-white ml-4" @click="openModal()"><i class="fas fa-sms" />
    <ModalHeadlessUI ref="modal">
      <template #default>
        <div>
          <h1 class="font-bold mb-2 text-3xl text-center">
            Send Mass Text
          </h1>
          <p class="text-center mb-4 text-l">(Sending to {{ selected.length }} Recipients)</p>
        </div>
        <form id="smsForm" name="smsForm" @submit.prevent="sendSms">
          <select-input :key="smsForm.smsTemplate.id" v-model="smsTemplate" class="pb-4 w-full" label="Select SMS Template" @change="onTemplateChange($event)">
            <option v-for="smsSingle in smsTemplateOptions" :key="smsSingle.id" :value="smsSingle.id">{{ smsSingle.title }}</option>
          </select-input>
          <textarea-input id="smsTemplate" v-model="smsForm.smsTemplate" :error="smsForm.errors.smsTemplate" name="smsTemplate" rows="3" class="w-full" />
          <div id="loan_error" class="hidden form-error" />
          <div class="text-right pb-4 text-sm"><span>{{ 1000 - smsForm.smsTemplate.length }} characters remaining</span></div>
          <div class="flex flex-wrap overflow-hidden">
            <div class="text-center text-m">
              <span class="cursor-pointer" @click="insertField('😊')">😊</span>
              <span class="cursor-pointer" @click="insertField('😆')">😆</span>
              <span class="cursor-pointer" @click="insertField('🤣')">🤣</span>
              <span class="cursor-pointer" @click="insertField('😜')">😜</span>
              <span class="cursor-pointer" @click="insertField('🤔')">🤔</span>
              <span class="cursor-pointer" @click="insertField('👍')">👍</span>
              <span class="cursor-pointer" @click="insertField('🙏')">🙏</span>
              <span class="cursor-pointer" @click="insertField('🥰')">🥰</span>
              <span class="cursor-pointer" @click="insertField('❤️')">❤️</span>
              <span class="cursor-pointer" @click="insertField('🎉')">🎉</span>
              <span class="cursor-pointer" @click="insertField('🔥')">🔥</span>
              <span class="cursor-pointer" @click="insertField('😍')">😍</span>
              <span class="cursor-pointer" @click="insertField('😂')">😂</span>
              <span class="cursor-pointer" @click="insertField('🙌')">🙌</span>
              <span class="cursor-pointer" @click="insertField('🤗')">🤗</span>
              <span class="cursor-pointer" @click="insertField('😎')">😎</span>
              <span class="cursor-pointer" @click="insertField('🏠')">🏠</span>
              <span class="cursor-pointer" @click="insertField('🏆')">🏆</span>
            </div>
            <div class="text-m w-full text-left hidden md:block">
              <!-- <span class="tag-input__tag text-sm cursor-pointer">Insert</span> -->
              <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%first%')">first</span>
              <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%nickname%')">nickname</span>
              <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%last%')">last</span>
              <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%phone%')">phone</span>
              <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%email%')">email</span>
              <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%address%')">address</span>
              <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%city%')">city</span>
              <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField('%zip%')">zip</span>
            </div>
          </div>
          <div class="flex justify-center items-center mt-5">
            <div>
              <loading-button :loading="smsForm.processing" class="btn-indigo ml-auto" type="submit">Send Mass Text</loading-button>
            </div>
          </div>
        </form>
      </template>
    </ModalHeadlessUI>
  </button>
</template>

<script>
import ModalHeadlessUI from '@/Shared/ModalHeadlessUI'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import { router } from '@inertiajs/vue3'

export default {
  components: {
    ModalHeadlessUI,
    TextareaInput,
    SelectInput,
    LoadingButton,
  },
  props: {
    lead: Object,
    selected: Array,
    smsTemplates: Array,
    auth: Object,
    url: String,
  },
  data() {
    return {
      smsForm: router.form({
        selected: this.selected,
        smsTemplate: '',
      }),
      userInfo:
        {
          user_email: this.auth.user.email,
          user_phone: this.auth.user.phone,
          user_first_name: this.auth.user.first_name,
          user_last_name: this.auth.user.last_name,
          user_nmls: this.auth.user.nmls,
          user_application_link: this.auth.user.application_link,
          user_appointment_link: this.auth.user.appointment_link,
        },
    }
  },
  computed:{
    smsTemplateOptions() {
      var smsTemplateOptions= this.smsTemplates
      return smsTemplateOptions
    },
    urlPost() {
      return this.url || '/smsMass'
    },
  },
  methods:{
    onTemplateChange: function(event){

      let smsTemplateId = parseInt(event.target.value)
      console.log(smsTemplateId)

      let message = this.smsTemplates.find(item => item.id === smsTemplateId).message

      Object.keys(this.userInfo).forEach(key => {
        const regex = new RegExp('%' + key + '%', 'g')
        message = message.replace(regex, this.userInfo[key])
        this.smsForm.smsTemplate = message.replace(/(<([^>]+)>)/gi, '')
      })
    },
    insertField(token) {
      // Get the text area element
      let textArea = document.getElementById('smsTemplate')

      // Save the current cursor position
      let cursorPos = textArea.selectionStart

      // Insert the emoji at the cursor position
      textArea.value = textArea.value.substring(0, cursorPos) + token + textArea.value.substring(cursorPos)

      // Update the cursor position to be after the inserted emoji
      textArea.selectionEnd = cursorPos + token.length

      this.smsForm.smsTemplate = textArea.value

      textArea.focus()
    },
    openModal() {
      this.$refs.modal.openModal()
    },
    closeModal() {
      this.$refs.modal.closeModal()
    },
    sendSms() {      
      const smsTemplateLower = this.smsForm.smsTemplate.toLowerCase()
      const loanErrorDiv = document.getElementById('loan_error')

      if (smsTemplateLower.includes('loan')) {
        loanErrorDiv.innerText = 'Remove the word "loan" from SMS message.'
        loanErrorDiv.classList.remove('hidden')
        return
      }

      if (smsTemplateLower.includes('credit repair')) {
        loanErrorDiv.innerText = 'Remove the word "credit repair" from SMS message.'
        loanErrorDiv.classList.remove('hidden')
        return
      }

      loanErrorDiv.classList.add('hidden')

      this.smsForm.selected = [...this.selected]

      this.smsForm.post(this.urlPost, {
        onSuccess: () => {
          this.smsForm.reset('smsTemplate')
          this.$emit('update:selected', [])
          this.closeModal()
          console.log('SMS SENT')
        },
      })
    },
  },
}
</script>
<style>
.tag-input__text {
  border: none;
  outline: none;
  line-height: 50px;
  background: none;
}
.tag-input__tag {
  height: 30px;
  float: left;
  margin-right: 10px;
  /* background-color: #eee; */
  margin-top: 10px;
  line-height: 30px;
  padding: 0 10px;
  border-radius: 5px;
}
.tag-input__tag > span {
  cursor: pointer;
  opacity: 0.75;
}
</style>
